import theme from '@ifca-root/react-component/src/assets/theme'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { SearchHeader } from '@ifca-root/react-component/src/components/Header/SearchHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
import {
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
  useMediaQuery,
  withStyles,
} from '@material-ui/core'
import { KeyboardArrowRight, MoreVert, Tune } from '@material-ui/icons'
import EventIcon from '@material-ui/icons/Event'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { advancedFilterList } from 'components/Filter/AdvancedFilter'
import {
  useGetArAdvancebyStatusLazyQuery,
  useGetArCreditNotebyStatusLazyQuery,
  useGetArDebitNotebyStatusLazyQuery,
  useGetArInvoicebyStatusLazyQuery,
  useGetArOfficialReceiptbyStatusLazyQuery,
  useGetArRefundbyStatusLazyQuery,
  useGetDebtorAccountQuery,
  useGetUsersByAccountAndSoftwareQuery,
} from 'generated/graphql'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'

/* -------------------------------------------- */
/*            For ACTIVE and APPROVED           */
/* -------------------------------------------- */
export const DebtorAccountTrxListing = (props: any) => {
  const { anchorEl, menu, handleClick, handleClose } = useMenuOption()

  const { docType } = props
  let history = useHistory()
  const { CompanyID, DebtorAccountID }: any = useParams()
  const getSearch = localStorage.getItem('searchFilter')
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })
  const GreyTooltip = withStyles({
    tooltip: {
      color: 'white',
      backgroundColor: '#9e9e9e',
    },
  })(Tooltip)

  const { filteredList, handleSearch, setOriginalListing } = useFuseSearch()

  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const {
    loading: UserLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: DebtorAccountLoading,
    data: { getDebtorAccount } = { getDebtorAccount: [] },
  } = useGetDebtorAccountQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID, DebtorAccountID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const totalDebtorDocAmt = getDebtorAccount?.reduce(
    (previousValue, currentValue) => previousValue + currentValue?.TotalAmt,
    0
  )
  const totalDocAmt = filteredList?.reduce(
    (previousValue, currentValue) => previousValue + currentValue?.DocAmt,
    0
  )

  const [
    loadARAdvance,
    {
      loading: getARAdvancebyStatusLoading,
      data: { getARAdvancebyStatus } = { getARAdvancebyStatus: [] },
    },
  ] = useGetArAdvancebyStatusLazyQuery({
    fetchPolicy: 'network-only',
    // variables: {
    //   CompanyID,
    //   StatusArr: [listStatus ?? 'ACTIVE'],
    // },
    onCompleted: ({ getARAdvancebyStatus }) => {
      setOriginalListing(getARAdvancebyStatus, v => {
        v['DocDateFormatted'] = formatDate(v.DocDate)
      })
    },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const [
    loadARInvoice,
    {
      loading: ARInvoicebyStatusLoading,
      data: { getARInvoicebyStatus } = { getARInvoicebyStatus: [] },
    },
  ] = useGetArInvoicebyStatusLazyQuery({
    fetchPolicy: 'network-only',
    // variables: {
    //   CompanyID,
    //   StatusArr: [listStatus ?? 'ACTIVE'],
    // },
    onCompleted: ({ getARInvoicebyStatus }) => {
      setOriginalListing(getARInvoicebyStatus, v => {
        v['DocDateFormatted'] = formatDate(v.DocDate)
      })
    },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const [
    loadARCreditNote,
    {
      loading: ARCreditNotebyStatusLoading,
      data: { getARCreditNotebyStatus } = { getARCreditNotebyStatus: [] },
    },
  ] = useGetArCreditNotebyStatusLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: ({ getARCreditNotebyStatus }) => {
      setOriginalListing(getARCreditNotebyStatus, v => {
        v['DocDateFormatted'] = formatDate(v.DocDate)
      })
    },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const [
    loadARDebitNote,
    {
      loading: ARDebitNotebyStatusLoading,
      data: { getARDebitNotebyStatus } = { getARDebitNotebyStatus: [] },
    },
  ] = useGetArDebitNotebyStatusLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: ({ getARDebitNotebyStatus }) => {
      setOriginalListing(getARDebitNotebyStatus, v => {
        v['DocDateFormatted'] = formatDate(v.DocDate)
      })
    },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const [
    loadAROfficialReceipt,
    {
      loading: getAROfficialReceiptbyStatusLoading,
      data: { getAROfficialReceiptbyStatus } = {
        getAROfficialReceiptbyStatus: [],
      },
    },
  ] = useGetArOfficialReceiptbyStatusLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: ({ getAROfficialReceiptbyStatus }) => {
      setOriginalListing(getAROfficialReceiptbyStatus, v => {
        v['DocDateFormatted'] = formatDate(v.DocDate)
      })
    },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const [
    loadARRefund,
    {
      loading: getARRefundbyStatusLoading,
      data: { getARRefundbyStatus } = { getARRefundbyStatus: [] },
    },
  ] = useGetArRefundbyStatusLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: ({ getARRefundbyStatus }) => {
      setOriginalListing(getARRefundbyStatus, v => {
        v['DocDateFormatted'] = formatDate(v.DocDate)
      })
    },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  useEffect(() => {
    if (docType === 'invoice') {
      loadARInvoice({
        variables: {
          CompanyID,
          StatusArr: ['COMPLETED'],
          DebtorAccountID,
        },
      })
    } else if (docType === 'credit-note')
      loadARCreditNote({
        variables: {
          CompanyID,
          StatusArr: ['COMPLETED'],
          DebtorAccountID,
        },
      })
    else if (docType === 'debit-note')
      loadARDebitNote({
        variables: {
          CompanyID,
          StatusArr: ['COMPLETED'],
          DebtorAccountID,
        },
      })
    else if (docType === 'advance')
      loadARAdvance({
        variables: {
          CompanyID,
          StatusArr: ['COMPLETED'],
          DebtorAccountID,
        },
      })
    else if (docType === 'official-receipt')
      loadAROfficialReceipt({
        variables: {
          CompanyID,
          StatusArr: ['COMPLETED'],
          DebtorAccountID,
        },
      })
    else if (docType === 'refund')
      loadARRefund({
        variables: {
          CompanyID,
          StatusArr: ['COMPLETED'],
          DebtorAccountID,
        },
      })
  }, [docType])

  let title,
    keyID,
    clickText,
    hasAllocation = false
  switch (docType) {
    case 'advance':
      title = 'Advance'
      keyID = 'AdvanceID'
      clickText = false
      hasAllocation = true
      break
    case 'invoice':
      title = 'Invoice'
      keyID = 'InvoiceID'
      clickText = true
      break
    case 'refund':
      title = 'Refund'
      keyID = 'RefundID'
      clickText = true
      break
    case 'debit-note':
      title = 'Debit Note'
      keyID = 'DebitNoteID'
      clickText = true
      break
    case 'official-receipt':
      title = 'Receipt'
      keyID = 'ReceiptID'
      clickText = true
      break
    case 'credit-note':
      title = 'Credit Note'
      keyID = 'CreditNoteID'
      clickText = true
      break
  }

  const user = JSON.parse(localStorage.getItem('loggedInUser'))

  return (
    <>
      {UserLoading && <Loading />}
      {DebtorAccountLoading && <Loading />}
      {ARInvoicebyStatusLoading && <Loading />}
      {ARDebitNotebyStatusLoading && <Loading />}
      {getARRefundbyStatusLoading && <Loading />}
      {ARCreditNotebyStatusLoading && <Loading />}
      {getARAdvancebyStatusLoading && <Loading />}
      {getAROfficialReceiptbyStatusLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(
            `/account-receivable/${CompanyID}/debtor-account/debtor-profile/${DebtorAccountID}`
          )
          localStorage.removeItem(`searchFilter`)
          localStorage.removeItem(`advancedFilter`)
        }}
        smTitle="Account Receivable"
        title={user?.companyName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Debtor Accounts' },
          { name: 'Debtor Accounts' },
          { name: title, current: true },
        ]}
      />
      {DebtorAccountID ? (
        <DynamicSubHeader
          title={
            <span>
              <span style={{ fontWeight: 'bold',}}>
                {getDebtorAccount[0]?.DebtorName}
              </span>
            </span>
          }
          infoLine={<span style={{ fontWeight: 'bold' }}>{title}</span>}
          rightInfoLine={
            <span>
              <span className="c-orange ">{amtStr(totalDocAmt)}</span>
            </span>
          }
        />
      ) : null}

      <div>
        <SearchHeader
          title={`${title} Listing`}
          value={`${advancedFilterList(filteredList)?.length}`}
          search
          fixed
          multiDynamicInfo
          onChangeAction={e => {
            handleSearch(e?.target?.value, [
              'DocNo',
              'RefNo',
              'DocDate',
              'Description',
            ])
          }}
          onCloseAction={() => handleSearch('', [])}
          option={{
            icon: <Tune />,
            onClick: () =>
              history.push(`/account-receivable/${CompanyID}/advance/filter`),
          }}
          isDefaultValue={!!getSearch}
          defaultValue={getSearch ? getSearch : ''}
        />
      </div>
      <ContentWrapper style={{ marginTop: isDesktop ? '153px' : '90px' }} float>
        <List className="core-list">
          {advancedFilterList(filteredList) === undefined ||
          advancedFilterList(filteredList)?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            advancedFilterList(filteredList)
              ?.sort((a, b) => {
                const dateSort = new Date(b.DocDate).getTime() - new Date(a.DocDate).getTime();
                if(dateSort !==0) return dateSort;
                return a.DocDate.localeCompare(b.DocDate)
                
              })
              ?.map((el, index) => {
                return (
                  <ListItem>
                    <ListItemText
                      primary={
                        <>
                          <span
                            className={`flex-space mdLabel ${!!clickText &&
                              'click-text'}`}
                            style={{ fontSize: '12px' }}
                            onClick={() =>
                              !!clickText &&
                              history.push({
                                pathname: `/account-receivable/${CompanyID}/debtor-account/debtor-profile/${DebtorAccountID}/${docType}/${el?.[keyID]}/preview`,
                                state: { ...el, DebtorProfile: true },
                              })
                            }
                          >
                            {el?.DocNo}
                          </span>
                          <span
                            className="desc"
                            style={{
                              fontSize: '12px',
                            }}
                          >
                            <span className="mdLabel">
                              <IconText
                                icon={<EventIcon />}
                                font="mdLabel"
                                children={formatDate(el?.DocDate)}
                              ></IconText>
                            </span>
                          </span>
                        </>
                      }
                      secondary={
                        <>
                          <Grid spacing={1} container className="table-content">
                            <Grid item xs={6}>
                              <span style={{ fontSize: '10px' }}>
                                {el?.DebtorAccount?.DebtorName}
                              </span>
                            </Grid>
                            <Grid
                              item
                              xs={6}
                              style={{
                                textAlign: 'end',
                              }}
                            >
                              <span className="xxTitle c-orange">
                                <span
                                  style={{
                                    fontSize: '10px',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  {amtStr(el?.DocAmt)}
                                </span>
                              </span>
                            </Grid>
                          </Grid>

                          <Grid spacing={1} container className="table-content">
                            <Grid item xs={6}>
                              <span style={{ fontSize: '10px' }}>
                                {el?.Allocation?.map(
                                  alloc =>
                                    alloc?.[`${alloc?.CreditOrDebit}DocNo`]
                                )?.join(' | ') ?? '-'}
                              </span>
                            </Grid>
                            <Grid
                              item
                              xs={6}
                              style={{
                                textAlign: 'end',
                              }}
                            >
                              <span
                                style={{
                                  fontSize: '10px',
                                  color: 'grey',
                                  fontWeight: 'bold',
                                }}
                              >
                                {amtStr(el?.BalanceAmt)}
                              </span>
                            </Grid>
                          </Grid>
                          <div>
                            <div
                              className="desc text-overflow"
                              style={{ width: '340px' }}
                            >
                              {el?.Description ?? el?.Remark}
                            </div>
                          </div>
                        </>
                      }
                    />
                    <ListItemSecondaryAction>
                      {hasAllocation ? (
                        <IconButton
                          edge="end"
                          aria-label="delete"
                          aria-controls="menu-list"
                          aria-haspopup="true"
                          onClick={e => handleClick(e, el?.[keyID], index, el)}
                          style={{ verticalAlign: '30px' }}
                        >
                          <MoreVert />
                        </IconButton>
                      ) : (
                        <IconButton edge="end" aria-label="arrow">
                          <KeyboardArrowRight
                            onClick={() =>
                              history.push({
                                pathname: `/account-receivable/${CompanyID}/debtor-account/debtor-profile/${DebtorAccountID}/${docType}/${el?.[keyID]}/detail`,
                                state: { ...el, DebtorProfile: true },
                              })
                            }
                          />
                        </IconButton>
                      )}
                    </ListItemSecondaryAction>
                  </ListItem>
                )
              })
          )}
        </List>
      </ContentWrapper>

      <Menu
        id="menu-list"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        <MenuItem
          onClick={() => {
            history.push({
              pathname: `/account-receivable/${CompanyID}/debtor-account/debtor-profile/${DebtorAccountID}/${docType}/${menu?.ID}/detail`,
              state: menu?.obj,
            })
          }}
        >
          View
        </MenuItem>
        <MenuItem
          onClick={() => {
            history.push({
              pathname: `/account-receivable/${CompanyID}/debtor-account/debtor-profile/${DebtorAccountID}/${docType}/${menu?.ID}/allocation`,
              state: menu?.obj,
            })
          }}
        >
          Allocation
        </MenuItem>
      </Menu>

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
